exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.styled-form__header {\n\tmargin-bottom: 20px;\n}\n\n", ""]);

// exports
